import { createFileRoute, Outlet } from '@tanstack/react-router';

import { buildRouteExport } from '~/utils/buildRouteExport';
import { createProtectedRoute } from '~/utils/routeProtection';

import { routeParams } from './-routeParams';

export const Route = createFileRoute('/(main)/settings/admin')({
  beforeLoad: createProtectedRoute({
    routePath: '/settings/admin',
    ...routeParams,
  }),
  component: Outlet,
});

export const ADMIN = buildRouteExport({
  Route,
  ...routeParams,
});
